module.exports = __webpack_public_path__ + "img/FroSmokes@2x.3a0fe0d0.webp";